import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-alertdialogue',
  templateUrl: './alertdialogue.component.html',
  styleUrls: ['./alertdialogue.component.css']
})
export class AlertdialogueComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<AlertdialogueComponent>) { }

  ngOnInit(): void {
  }
  ok = () => {
    this.dialogRef.close(true);
  }
  cancel = () => {
    this.dialogRef.close(false);
  }
}
